const BloodType = {
  0: 'O_MINUS',
  1: 'O_PLUS',
  2: 'A_MINUS',
  3: 'A_PLUS',
  4: 'B_MINUS',
  5: 'B_PLUS',
  6: 'AB_MINUS',
  7: 'AB_PLUS',
  8: 'HH',
  9: 'UNKNOWN',

  DEFAULT: 9,
};

const OrganDonor = {
  0: 'YES',
  1: 'NO',
  2: 'UNKNOWN',
  DEFAULT: 2,
};

const PersonalData = class {
  constructor(data = {}) {
    this.data = data;
  }

  get name() {
    return this.data.name || '';
  }

  set name(val) {
    this.data.name = val;
  }

  get address() {
    return this.data.address || '';
  }

  set address(val) {
    this.data.address = val;
  }

  get bloodType() {
    return 'bloodType' in this.data ? this.data.bloodType : BloodType.DEFAULT;
  }

  set bloodType(val) {
    this.data.bloodType = val;
  }

  get allergies() {
    return this.data.allergies || '';
  }

  set allergies(val) {
    this.data.allergies = val;
  }

  get medications() {
    return this.data.medications || '';
  }

  set medications(val) {
    this.data.medications = val;
  }

  get organDonor() {
    return 'organDonor' in this.data ? this.data.organDonor : OrganDonor.DEFAULT;
  }

  set organDonor(val) {
    this.data.organDonor = val;
  }

  get medicalConditions() {
    return this.data.medicalConditions || '';
  }

  set medicalConditions(val) {
    this.data.medicalConditions = val;
  }

  get toFB() {
    return {
      name: this.name,
      address: this.address,
      bloodType: this.bloodType,
      allergies: this.allergies,
      medications: this.medications,
      organDonor: this.organDonor,
      medicalConditions: this.medicalConditions,
    };
  }

  static isValid(data) {
    const keys = [
      'address',
      'allergies',
      'bloodType',
      'medicalConditions',
      'medications',
      'name',
      'organDonor',
    ];
    if (data) return keys.every(item => item in data);
    return false;
  }
};

const AlarmInvoke = {
  0: 'ThreeClick',
  1: 'LongClick',
  2: 'Off',

  DEFAULT: 2,
};

const AlarmSettings = class {
  constructor(data = {}) {
    this.data = data;
  }

  get invokeMethod() {
    return 'alarmInvokeMethod' in this.data ? this.data.alarmInvokeMethod : AlarmInvoke.DEFAULT;
  }

  set invokeMethod(val) {
    this.data.alarmInvokeMethod = val;
  }

  get enabled() {
    return 'enableAlarmSignal' in this.data ? this.data.enableAlarmSignal : false;
  }

  set enabled(val) {
    this.data.enableAlarmSignal = val;
  }

  get message() {
    return 'sendMessageToAll' in this.data ? this.data.sendMessageToAll : false;
  }

  set message(val) {
    this.data.sendMessageToAll = val;
  }

  get messageText() {
    return 'emergencyMessageText' in this.data ? this.data.emergencyMessageText : '';
  }

  set messageText(val) {
    this.data.emergencyMessageText = val;
  }

  get call() {
    return 'callToAll' in this.data ? this.data.callToAll : false;
  }

  set call(val) {
    this.data.callToAll = val;
  }

  get emegerency() {
    return 'callEmergencyNumber' in this.data ? this.data.callEmergencyNumber : false;
  }

  set emegerency(val) {
    this.data.callEmergencyNumber = val;
  }

  get location() {
    return 'addSmsLocation' in this.data ? this.data.addSmsLocation : false;
  }

  set location(val) {
    this.data.addSmsLocation = val;
  }

  get toFB() {
    return {
      alarmInvokeMethod: this.invokeMethod,
      enableAlarmSignal: this.enabled,
      callToAll: this.call,
      sendMessageToAll: this.message,
      emergencyMessageText: this.messageText,
      callEmergencyNumber: this.emegerency,
      addSmsLocation: this.location,
    };
  }

  static isValid(data) {
    const keys = [
      'addSmsLocation',
      'alarmInvokeMethod',
      'callEmergencyNumber',
      'callToAll',
      'emergencyMessageText',
      'enableAlarmSignal',
      'sendMessageToAll',
    ];
    if (data) return keys.every(item => item in data);
    return false;
  }
};

const ICEContacts = class {
  constructor(data = {}, contacts = []) {
    this.data = data;
    this.contacts = contacts;
  }

  get toFB() {
    return this.data;
  }

  static isValid(data) {
    return data;
  }

  getContacts() {
    const contacts = [];
    if (Object.keys(this.data).length !== 0) {
      const ice = Object.assign(
        ...Object.entries(this.data).map(item => ({ [item[1].contactId]: item[0] })),
      );
      const iceContactID = Object.keys(ice);
      this.contacts.forEach((item) => {
        if (iceContactID.includes(item.id)) {
          item.setIcekey(ice[item.id]);
          contacts.push(item);
        }
      });
    }
    return contacts;
  }
};

export {
  PersonalData,
  ICEContacts,
  AlarmSettings,
  BloodType,
  OrganDonor,
  AlarmInvoke,
};



// WEBPACK FOOTER //
// ./src/store/models/sos.js